import { Component, Output, Input, EventEmitter, OnInit } from "@angular/core";
import { TimeParams } from "../../models/TimeParams";
import { TimeProvider } from "../../providers/time/time";
import { ModalController } from "ionic-angular";
import { TimeControlComponent } from "../time-control/time-control";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "timecontrol-toolbar",
  templateUrl: "timecontrol-toolbar.html",
})
export class TimecontrolToolbarComponent implements OnInit {
  @Input() title;
  @Input() compare;
  timeParamsChanges: BehaviorSubject<TimeParams>;
  @Output() ontimeParamsChanges: EventEmitter<TimeParams> =
    new EventEmitter<TimeParams>();
  @Input() showTimeSelector = true;

  from: string;
  to: string;
  timeRange = 7;

  constructor(
    public time: TimeProvider,
    private modalController: ModalController
  ) {
    this.timeParamsChanges = new BehaviorSubject<TimeParams>(
      this.time.getTimeParams(7)
    );
  }

  ngOnInit() {
    this.timeParamsChanges.subscribe((t) => {
      if (t) {
        this.from = this.validDateFormat(t.from);
        this.to = this.validDateFormat(t.to);
        this.timeRange = t.range;
        this.ontimeParamsChanges.emit(t);
      }
    });
  }

  onEdit(): void {
    this.modalController
      .create(TimeControlComponent, {
        changes: this.timeParamsChanges,
      })
      .present();
  }

  validDateFormat(dateString) {
    if (dateString) {
      return dateString.replace(/\s/, "T");
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/timecontrol-toolbar/timecontrol-toolbar.ts